import {E, GetEntries, emptyArray} from "js-vextensions";
import moment from "moment";
import {Button, Column, Div, Grid, Row, Select, Text} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {GetJournalEntries} from "../../Server/DB/journalEntries.js";
import {JournalEntry, JournalSegment} from "../../Server/DB/journalEntries/@JournalEntry.js";
import {GetUser, Me, MeID} from "../../Server/DB/users.js";
import {GetSelectedJournalEntry, JournalDisplayMode} from "../../Store/main/journal.js";
import {Link, PageContainer, Observer, RunInAction, RunInAction_Set} from "web-vcore";
import {ES} from "web-vcore";
import {User} from "../../Server/DB/users/@User.js";
import {GetUserPermissionGroups} from "../../Server/DB/users/$user.js";
import {runInAction} from "mobx";
import {store} from "../../Store/index.js";
import {AddJournalEntry} from "../../Server/Commands/JournalEntryCommands.js";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel.js";
import {JournalEntryUI} from "./JournalEntryUI.js";
import {useExpandedNavBar} from "../@Shared/NavBar.js";
import {EntryGrid} from "./EntryGrid.js";
import {EntryList} from "./EntryList.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {DreamList} from "./DreamList.js";
import {SceneList} from "./SceneList.js";
import {JournalImporterUI} from "./Importer.js";

//type JournalTab = "list" | "entry";

export const JournalUI = observer_mgl((props: {user: User})=>{
	const {user} = props;
	const uiState = store.main.journal;
	//if (user == null) return <PageContainer>You must be signed in to access this page.</PageContainer>;
	const permissions = GetUserPermissionGroups(MeID());
	const entries: JournalEntry[] = user ? GetJournalEntries(user.id, "desc") : emptyArray;
	const selectedEntry = GetSelectedJournalEntry();

	if (selectedEntry) {
		return <PageContainer preset="full" style={{margin: 0, padding: 0, height: "100%", background: "none"}}>
			<JournalEntryUI entry={selectedEntry}/>
		</PageContainer>;
	}

	/*const largeVersion = useExpandedNavBar();
	if (!largeVersion) {*/
	return (
		<PageContainer preset="full" style={{margin: 0, padding: 0, height: "100%", background: "none"}}>
			{uiState.displayMode == JournalDisplayMode.entryList && <EntryList entries={entries}/>}
			{uiState.displayMode == JournalDisplayMode.entryGrid && <EntryGrid entries={entries}/>}
			{uiState.displayMode == JournalDisplayMode.dreamList && <DreamList entries={entries}/>}
			{uiState.displayMode == JournalDisplayMode.sceneList && <SceneList entries={entries}/>}
			{uiState.displayMode == JournalDisplayMode.importer && <JournalImporterUI/>}
		</PageContainer>
	);

	/*return (
		<PageContainer style={{flex: 1, flexDirection: "row", margin: 20, padding: 0, height: "100%", background: "none"}}>
			<EntriesListComp {...{entries, selectedEntry}}/>
			<Column ml={10} style={ES({flex: 70})}>
				{selectedEntry && <JournalEntryUI entry={selectedEntry}/>}
			</Column>
		</PageContainer>
	);*/
});

export const JournalDisplayModeSwitcher = observer_mgl(()=>{
	const uiState = store.main.journal;
	const options = GetEntries(JournalDisplayMode, a=>{
		if (a == JournalDisplayMode.entryList) return "List";
		if (a == JournalDisplayMode.entryGrid) return "Grid";
		if (a == JournalDisplayMode.dreamList) return "Dreams";
		if (a == JournalDisplayMode.sceneList) return "Scenes";
		if (a == JournalDisplayMode.importer) return "Importer";
		return a;
	});
	return (
		<Select displayType="button bar" options={options}
			value={uiState.displayMode} onChange={val=>RunInAction_Set(()=>uiState.displayMode = val)}/>
	);
});